document.addEventListener('DOMContentLoaded', () => {

  // 1. Mobile Menu Tabs
  const tabLinks = document.querySelectorAll('.mobile_menu .tabs a');
  tabLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      if (!link.classList.contains('strongLink')) {
        e.preventDefault();
        
        // Remove active class from all tabs
        tabLinks.forEach(l => l.classList.remove('active'));
        // Add active class to clicked tab
        link.classList.add('active');

        // Hide all tab content
        const tabContents = document.querySelectorAll('.tabs_cont > div');
        tabContents.forEach(content => {
          content.style.display = 'none';
          content.classList.remove('active');
        });

        // Show target content
        const targetSelector = link.getAttribute('href');
        const targetBlock = document.querySelector(targetSelector);
        if (targetBlock) {
          // jQuery .fadeIn() roughly equates to display block + opacity handling. 
          // We set display block and add the active class immediately for performance.
          targetBlock.style.display = 'block';
          targetBlock.classList.add('active');
        }
      }
    });
  });

  // 2. Nav Toggle
  const navToggles = document.querySelectorAll('.custom-nav-toggle');
  navToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      if (toggle.classList.contains('mobile-nav--open')) {
        toggle.classList.remove('mobile-nav--open');
        toggle.classList.add('mobile-nav--close');
      } else {
        toggle.classList.add('mobile-nav--open');
        toggle.classList.remove('mobile-nav--close');
      }
      
      const mobileMenu = document.querySelector('.mobile_menu');
      if (mobileMenu) mobileMenu.classList.toggle('show');
    });
  });

  // 3. Hide Menu Button
  const hideMenuBtns = document.querySelectorAll('.hide_menu');
  hideMenuBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const siteHeaderMenu = document.querySelector('.site-header__menu');
      const mobileMenu = document.querySelector('.mobile_menu');

      if (siteHeaderMenu) {
        siteHeaderMenu.classList.add('mobile-nav--open');
        siteHeaderMenu.classList.remove('mobile-nav--close');
      }
      if (mobileMenu) {
        mobileMenu.classList.toggle('show');
      }
    });
  });

  // 4. Submenu (Has Child)
  const hasChildLinks = document.querySelectorAll('a.has_child');
  hasChildLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      const parentMenu = link.closest('.mobile_menu');
      if (parentMenu) parentMenu.classList.add('viewSide');

      const closestLi = link.closest('li');
      const subMenuUl = closestLi ? closestLi.querySelector('ul') : null;
      
      if (subMenuUl) {
        const menuHtml = subMenuUl.innerHTML;
        const title = link.textContent;
        
        const sideDataName = document.querySelector('.side_data .name');
        const sideDataMenuUl = document.querySelector('.side_data .menu ul');
        
        if (sideDataName) sideDataName.innerHTML = title;
        if (sideDataMenuUl) sideDataMenuUl.innerHTML = menuHtml;
      }
    });
  });

  // 5. Back Button (Side Data Name)
  const sideDataName = document.querySelector('.side_data .name');
  if (sideDataName) {
    sideDataName.addEventListener('click', function() {
      const parentMenu = this.closest('.mobile_menu');
      if (parentMenu) parentMenu.classList.remove('viewSide');
    });
  }

  // 6. Header Mobile Nav Toggle (Scroll Top)
  const headerNavToggle = document.querySelector('header .js-mobile-nav-toggle');
  if (headerNavToggle) {
    headerNavToggle.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      const bottomToggle = document.querySelector('.bottom_nav .js-mobile-nav-toggle');
      if (bottomToggle) {
        bottomToggle.classList.toggle('mobile-nav--open');
        bottomToggle.classList.toggle('mobile-nav--close');
      }
      e.preventDefault();
    });
  }

  // 7. Bottom Nav Toggle (Scroll Top)
  const bottomNavToggle = document.querySelector('.bottom_nav .js-mobile-nav-toggle');
  if (bottomNavToggle) {
    bottomNavToggle.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      const headerToggle = document.querySelector('header .js-mobile-nav-toggle');
      if (headerToggle) {
        headerToggle.classList.toggle('mobile-nav--open');
        headerToggle.classList.toggle('mobile-nav--close');
      }
      e.preventDefault();
    });
  }

  // 8. Product Card Variants (Event Delegation)
  document.addEventListener('click', (e) => {
    const option = e.target.closest('.product-card-wrapper .card__variants-option');
    if (option) {
      if (!option.classList.contains('card__variants-option-active')) {
        const wrapper = option.closest('.card__variants');
        if (wrapper) {
          const activeOption = wrapper.querySelector('.card__variants-option-active');
          if (activeOption) activeOption.classList.remove('card__variants-option-active');
        }
        
        option.classList.add('card__variants-option-active');

        const imageSrc = option.getAttribute('featured');
        const hoverSrc = option.getAttribute('hover');
        const url = option.getAttribute('href');
        
        const cardWrapper = option.closest('.product-card-wrapper');
        if (cardWrapper) {
          const featuredImg = cardWrapper.querySelector('.product-card-image-featured');
          const hoverImg = cardWrapper.querySelector('.product-card-image-hover');
          const link = cardWrapper.querySelector('.full-unstyled-link');

          if (featuredImg) featuredImg.setAttribute('srcset', imageSrc);
          if (hoverImg) hoverImg.setAttribute('srcset', hoverSrc);
          if (link) link.setAttribute('href', url);
        }
      }
      e.preventDefault(); // Equivalent to return false
    }
  });

  // 9. Watch Fit Button (Event Delegation)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.custom-watch-fit-button')) {
      const fitInput = document.getElementById('custom_watch_fit');
      const wristInput = document.getElementById('wrist_size');
      if (fitInput && wristInput) {
        wristInput.value = fitInput.value;
      }
    }
  });

});